import View from '../../../Core/View.js';
import requestAnimationFrame from 'raf';

const FIXED_CLASS = 'navigation--sticky';

export default class extends View {

	initialize() {
		this.reference = $('.navigation-reference').get(0);
		this.currentlySticky = false;

		// Don't check in scroll event, check in raf (better performance)
		this.checkStickyness = this.checkStickyness.bind(this);
		requestAnimationFrame(this.checkStickyness);
	}

	checkStickyness() {
		if (this.reference.getBoundingClientRect().top < 0) {
			this.stick();
		} else {
			this.unstick();
		}

		requestAnimationFrame(this.checkStickyness);
	}

	stick() {
		if (this.currentlySticky) {
			return;
		}

		this.currentlySticky = true;
		this.el.classList.add(FIXED_CLASS);
	}

	unstick() {
		if (! this.currentlySticky) {
			return;
		}

		this.currentlySticky = false;
		this.el.classList.remove(FIXED_CLASS);
	}
}


// WEBPACK FOOTER //
// ./js/Views/Templates/Navigation/StickyMenu.js